jQuery(document).ready(function() {
  
  Shopify.queue = [];
  
  var add_to_cart_error_messages = [];
  
  //Qty. Validation
  function isNumber(evt) 
  {
    	evt = (evt) ? evt : window.event;
    	var charCode = (evt.which) ? evt.which : evt.keyCode;
    	if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        	return false;
    	}
    	return true;
  }
  
  //Push Variant into Current List with Qty.
  function pushItems(variant_id,variant_qty) 
  {
    //If Variant is already added then update it's qty.
    Shopify.queue = jQuery.grep(Shopify.queue,function(e){ 
    		if(e.variantId == variant_id) {
       		return false;
     		} else {
       		return true;
        	}
     });   
     
     //Push Variants in Queue for adding all to cart
  	 Shopify.queue.push({variantId: variant_id,quantity: variant_qty });
  }
  
  //Remove Variant From Current List if Qty. becomes zero.
  function currentListRemove(variant_id)
  {
    //786 ALLAH
    Shopify.queue = jQuery.grep(Shopify.queue,function(e){ 
    	if(e.variantId == variant_id) {
       		return false;
     	} else {
       		return true;
    	}
   	 });   
     	
     return true;
   }
  
  //On click of Show Option Button then display Pop-up
  jQuery(".show_option").click(function(e) {
  	e.preventDefault();
    
    //Show Pop-up
    jQuery("#show_option_modal").css("display","block");
    
    //Get variants of product and display it in popup
    var prd_handle = jQuery(this).attr("data-prd-handle");
    var prd_url = "/products/"+prd_handle+"?view=show_option";
     
  	jQuery.ajax({
        type: 'GET',
        url: prd_url,
        success: function(data) {
            jQuery("#show_option_variants_tbl").html(data);
          
          	//Android - Chrome browser Fix to allow numbers only when type in qty. box
  			if(/Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent)) {	
  				jQuery(".list-product-qty").prop('type','number');
  			} else {                       
   				jQuery(".list-product-qty").prop('type','text');
  			}
        }
	}); 
  });
  
  //On click of close button hide Show Option Modal Popup
  jQuery(document).on("click",'.show_option_close',function(e) {
    	e.preventDefault();
  		jQuery("#show_option_modal").css('display','none'); 
    	jQuery("#show_option_variants_tbl").html("");
  });
  
  //On click of close button hide message Modal Popup
  jQuery(document).on("click",'.add_to_cart_message_modal .message_modal_close,.add_to_cart_message_modal .continue_btn',function(e) {
    	e.preventDefault();
  		jQuery("#add_to_cart_message_modal").css('display','none'); 
    	jQuery("#show_option_modal").css('display','none'); 
    	jQuery("#show_option_variants_tbl").html("");
    	jQuery("#add_to_cart_message_modal .error_msg").html("");
    	jQuery("#add_to_cart_message_modal .success_msg").html("");
  });
  
  //Qty. Increment
  jQuery(document).on('click','.qtyplus',function() {     
       	var ele_id = jQuery(this).siblings(".list-product-qty").attr("id");
		var var_id = ele_id.replace("updates_", "");
    	var qtyInput = jQuery("#"+ele_id);
  		var currentVal = parseInt(qtyInput.val()) || 0;
    	var newQty = currentVal+1;
    	var qtyMax = parseInt(qtyInput.attr('max'));
          	
         if(currentVal >= qtyMax) {
        	alert("We have maximum "+qtyMax+" items in stock.");
   		 	qtyInput.val(qtyMax);  
  		} else {
  			qtyInput.val(newQty);
          	
    		//Push Items
    		pushItems(var_id,newQty);
        }
    
   });
  
  //Qty. Decrement
  jQuery(document).on('click','.qtyminus',function() {    
       	var ele_id = jQuery(this).siblings(".list-product-qty").attr("id");
       	var var_id = ele_id.replace("updates_", "");
    	var qtyInput = jQuery("#"+ele_id);
  		var currentVal = parseInt(qtyInput.val());
    	var newQty = currentVal-1;
    
    	if(currentVal>= 1) {
      		qtyInput.val(newQty);
            pushItems(var_id,newQty);
        } 
    
    	if(newQty==0) {
           currentListRemove(var_id);
        }
  });
  
  //Qty. Type in Qty. Textbox
  jQuery(document).on('keypress','.list-product-qty',function(evt) {
       var isno = isNumber(evt);
       if(!isno) {
         return false;
       }
  });
  
  //On key up check qty. value across stock values.
  jQuery(document).on('keyup','.list-product-qty',function() {
        var ele_id = jQuery(this).attr("id");
    	var var_id = ele_id.replace("updates_", "");
    	var qtyInput = jQuery("#"+ele_id);
        var currentVal = parseInt(qtyInput.val()) || 0;
  		var qtyMax = parseInt(qtyInput.attr('max'));
            
  		if(currentVal > qtyMax) {
          	alert("We have maximum "+qtyMax+" items in stock.");
   		 	qtyInput.val(qtyMax);	
          	pushItems(var_id,qtyMax);
        } else {
        	if(currentVal >= 1) {
  				pushItems(var_id,currentVal);
        	} else {
          		//786 ALLAH
           		currentListRemove(var_id);
        	}
        }
   });
  
   //Add to cart button clicked
   jQuery(document).on('click',"#show_option_add_to_cart",function(e) {
    	e.preventDefault();
     	
     	if(Shopify.queue.length == 0) {
          alert("Sorry! No Items were added, Please fill Quantity field first then click on Add to Cart button.");
        } else {
     		
    		//console.log(Shopify.queue);
          	jQuery("#add_to_cart_message_loading").css("display","block");
          	Shopify.moveAlong();
        }
   });
  jQuery(document).on('click',"#show_option_add_to_cart_inner",function(e) {
    	e.preventDefault();
     	
     	if(Shopify.queue.length == 0) {
          alert("Sorry! No Items were added, Please fill Quantity field first then click on Add to Cart button.");
        } else {
     		
    		//console.log(Shopify.queue);
          	jQuery("#add_to_cart_message_loading").css("display","block");
          	Shopify.moveAlong();
          jQuery('.quickShopclose').click();
        }
   });  
   //Multiajax Add to Cart - Rivets JS Function
   Shopify.moveAlong = function() {
     	 var err_cnt = 0;
     	 
     	 //If we still have requests in the queue, let's process the next one.
	 	 if(Shopify.queue.length>0) {  
            var qty_cnt = 0;
           
           	//Hide Pop-up
    		jQuery("#show_option_modal").css("display","none");
           	
            //Show Message Popup
    		jQuery("#add_to_cart_message_modal").css("display","block");
               
           	jQuery.each(Shopify.queue, function(i,v){
          		CartJS.addItem(this.variantId, this.quantity,{}, {
          			"success": function(data,textStatus,jqXHR){
                      		qty_cnt = qty_cnt+Shopify.queue[i].quantity;
                      		
                    	  	jQuery("#add_to_cart_message_modal").find(".success_msg").html("<span class='cart_success_cnt' style='display:none;'>"+qty_cnt+"</span>");
                    },
          			"error": function(jqXHR){	
                      		err_cnt++;
                  			var response = eval('(' + jqXHR.responseText + ')');
            				response = response.description;
                     		add_to_cart_error_messages.push({'err_res':response});  
            		}
      			});
           });
      	} 
     
     
   };
  
   //Reset current List after Multicart performed - Cart Request Complete
   jQuery(document).on('cart.requestComplete',function(event,cart) {
     	//Hide Loading
     	jQuery("#add_to_cart_message_loading").css("display","none");
     
      	 //Update Header Cart Count
      	 if(jQuery('#CartCount').length>0) {
          	jQuery('#CartCount').html(cart.item_count); 
         } else {
            jQuery(".headerCart").find(".content-text").prepend('<div id="CartCount" class="site-header__cart-count"><span>'+cart.item_count+'</span><span class="icon__fallback-text medium-up--hide">items</span></div>');
         } 
       	
     	//Show all Errors if any item is not being added to cart.
     	if(add_to_cart_error_messages.length>1) {
           jQuery.each(add_to_cart_error_messages,function(index,value) {
              	index = index+1;
     			jQuery("#add_to_cart_message_modal .error_msg").css("display","block");
        		jQuery("#add_to_cart_message_modal .error_msg").append("<p>Error-"+index+": "+value.err_res+"</p>");
        	});
     	} 
     
     	if(add_to_cart_error_messages.length == 1) {
          	jQuery("#add_to_cart_message_modal .error_msg").css("display","block");
        	jQuery("#add_to_cart_message_modal .error_msg").append("<p>Error: "+add_to_cart_error_messages[0].err_res+"</p>");
     	}
     
     	//Get success count.
     	var success_cnt = jQuery("#add_to_cart_message_modal").find(".cart_success_cnt").html();
     	if(success_cnt>1) {
          jQuery("#add_to_cart_message_modal").find(".success_msg").append("<span class='cart_msg'>"+success_cnt+" items are added to cart successfully.</span>");
     	}
     
     	if(success_cnt==1) {
            jQuery("#add_to_cart_message_modal").find(".success_msg").append("<span class='cart_msg'>"+success_cnt+" item is added to cart successfully.</span>");
     	}
     
     	//Clear arrays.
     	Shopify.queue = [];
     	add_to_cart_error_messages = [];
   	});                    
});
